import { Text, Title } from "@mantine/core";
import { PDFPage } from "./PDFPage";
import { PieChart, Pie, Cell, ResponsiveContainer, PieLabel } from "recharts";
import useReportStore from "../../../store/useReportStore";

interface Skill {
  name: string;
  color: string;
  value: number;
  text_pdf: string;
  text: string;
}

const skillColors = ["#de57cc", "#a855f7", "#6f40e2", "#3a8bd9"];

function mapSkillsToMaster(
  roadmapSkills: { title: string; description: string }[]
): { future_skills: Skill[] } {
  return {
    future_skills: roadmapSkills.map((skill, index) => ({
      name: skill.title,
      color: skillColors[index % skillColors.length],
      value: 1,
      text_pdf: skill.description,
      text: skill.description,
    })),
  };
}

const RADIAN = Math.PI / 180;

const renderLabel: PieLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  name,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <foreignObject
      x={x - 140}
      y={y - 50}
      width="250"
      height="100%"
      color="#fff"
      style={{
        textAlign: "center",
        wordWrap: "break-word",
      }}
    >
      <Title
        size={27}
        ta="center"
        c="#FFF"
        maw={185}
        lh="37px"
        style={{
          maxWidth: "185px",
          wordWrap: "break-word",
          overflowWrap: "break-word",
          textOverflow: "ellipsis",
          overflow: "hidden",
          margin: "0 auto",
          paddingLeft: "20px",
        }}
      >
        {name}
      </Title>
    </foreignObject>
  );
};

export const FutureSkillsPDF = () => {
  const { report } = useReportStore();

  const content = report?.skills_to_master || [];

  const mappedSkills = mapSkillsToMaster(content.data);

  return (
    <PDFPage padding>
      <Title size={48} mb={8}>
        {content?.mark_down ? content?.mark_down?.replace("##", "") : ""}
      </Title>
      <Text mb={48} size="28px" lh="42px" c="dimmed">
        {content?.explanation ? content?.explanation : ""}
      </Text>
      <ResponsiveContainer width="100%" height={872}>
        <PieChart>
          <Pie
            data={mappedSkills.future_skills}
            cx="50%"
            cy="50%"
            outerRadius={436}
            innerRadius={190}
            label={renderLabel}
            labelLine={false}
            dataKey="value"
            startAngle={45}
            endAngle={450}
          >
            {mappedSkills.future_skills.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      {mappedSkills.future_skills.map((item, index) => (
        <Text key={index} mt={14} size="22px" lh="28px">
          <b>{item.name}</b>: {item.text_pdf}
        </Text>
      ))}
    </PDFPage>
  );
};
